import { App } from 'vue'
import InputList from './LpInputList.vue'

InputList.install = (Vue: App) => {
  Vue.component(InputList.name, InputList)
}

export default InputList
